import { useEffect } from 'react';
import { trackEvent } from '../lib/analytics';

// Sections to track (DOM id -> readable name). Fires a GA4 'section_view'
// event once per section per page load when it becomes 50%+ visible,
// so you can see how far visitors scroll and what content drives enquiries.
const SECTIONS = [
  ['about', 'About'],
  ['clients', 'Trusted By'],
  ['services', 'Services'],
  ['process', 'Process'],
  ['why-me', 'Why Me'],
  ['faq', 'FAQ'],
  ['contact', 'Contact'],
];

const SectionTracker = () => {
  useEffect(() => {
    const names = Object.fromEntries(SECTIONS);
    const seen = new Set();

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const id = entry.target.id;
          if (entry.isIntersecting && !seen.has(id)) {
            seen.add(id);
            trackEvent('section_view', {
              section_id: id,
              section_name: names[id] || id,
            });
          }
        });
      },
      // threshold 0 + negative bottom margin fires once the section scrolls
      // into the upper ~80% of the viewport — reliable regardless of how tall
      // the section is (fixes tall sections never hitting a 0.5 ratio on mobile).
      { threshold: 0, rootMargin: '0px 0px -20% 0px' }
    );

    const timer = setTimeout(() => {
      SECTIONS.forEach(([id]) => {
        const el = document.getElementById(id);
        if (el) observer.observe(el);
      });
    }, 300);

    return () => {
      clearTimeout(timer);
      observer.disconnect();
    };
  }, []);

  return null;
};

export default SectionTracker;
